// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"b3ee97f0","255":"bbc37244","676":"27c712f1","788":"78e70b7d","996":"741b4dd8"}[chunkId] + ".chunk.js";
};